import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import { ChevronLeft, Share2, Clock, Loader2 } from 'lucide-react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';

const BlogDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Marvel Sato | Detailed Blog"; 
    const fetchBlogDetail = async () => {
      try {
        // Fetching by imageId
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/blog/blog/${id}`);
        setBlog(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching blog details:", error);
        setLoading(false);
      }
    };

    fetchBlogDetail();
  }, [id]);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center text-orange-500">
        <Loader2 className="animate-spin" size={40} />
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="h-screen flex flex-col items-center justify-center space-y-4">
        <h1 className="text-2xl font-black uppercase italic text-slate-900">Insight Not Found</h1>
        <Link to="/blog" className="text-orange-500 font-bold uppercase text-xs underline">Return to Blogs</Link>
      </div>
    );
  }

  return (
    <div className="bg-white">
      <Header />
      
      <div className="pt-32 pb-20 px-6 max-w-4xl mx-auto">
        <Link to="/blog" className="flex items-center gap-2 text-slate-400 hover:text-orange-500 font-bold uppercase text-xs mb-8 transition-colors">
          <ChevronLeft size={16} /> Back to Insights
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1 className="text-3xl md:text-5xl font-black text-slate-900 italic uppercase leading-tight mb-6">
            {blog.title}
          </h1>
          
          <div className="flex items-center gap-6 mb-10 border-y border-slate-100 py-4">
             <div className="flex items-center gap-2 text-slate-500 text-sm">
                <Clock size={18}/> {blog.readTime || '5'} Min Read
             </div>
             <div className="flex items-center gap-2 text-slate-500 text-sm">
                <Share2 size={18} className="cursor-pointer hover:text-orange-500"/> Share
             </div>
          </div>

          <img 
            src={blog.image} 
            className="w-full h-[400px] object-cover rounded-3xl mb-10 shadow-2xl"
            alt={blog.title}
          />

          {/* This div renders the actual HTML content from your MongoDB */}
          <div 
            className="prose prose-lg max-w-none text-slate-600 leading-relaxed space-y-6 font-medium"
            dangerouslySetInnerHTML={{ __html: blog.content }}
          />
        </motion.div>
      </div>

      <Footer />
    </div>
  );
};

export default BlogDetail;